export default __webpack_public_path__ + "static/media/425property-gallery1.2425e69f.webp";